import { useQueryClient } from '@tanstack/react-query'
import { Logger, type EntityId, type Preference } from '@terros/common'
import { preferenceKey } from '../keys'

const logger = new Logger('usePreferenceCache')

// logger.level = 'verbose'

type PreferenceCache = {
  clearItem: (preference: Preference, targetId?: EntityId) => void
}

export function usePreferenceCache(): PreferenceCache {
  const queryClient = useQueryClient()
  return {
    clearItem: (preference: Preference, targetId?: EntityId) => {
      logger.verbose('clearItem', preference)
      queryClient.resetQueries({ queryKey: preferenceKey(preference, targetId) })
    },
  }
}
